import { Injectable } from '@angular/core';
import { AuthService } from './auth.service';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Router } from '@angular/router';
import { FlashMessagesService } from 'flash-messages-angular';
import { RouteService } from 'src/app/core/services';

@Injectable({
  providedIn: 'root'
})
export class UserService {

  // User object TODO: Make a user model?
  user = {
    signup: '',
    email: '',
    password: '',
    ageUnder18: false,
    firstName: '',
    middleInitial: '',
    lastName: '',
    primaryRole: '',
    primaryRoleOther: '',
    companyName: '',
    dob: '',
    race: '',
    ethnicity: '',
    disabled: '',
    numberOfChildren: '',
    maritalStatus: '',
    familyStatus: '',
    education: '',
    annualIncome: '',
    sourceOfIncome: '',
    streetAddress: '',
    secondary: '',
    phone: '',
    city: '',
    state: '',
    zipCode: '',
    county: '',
    primaryResidence: '',
    livingSituation: '',
    coordinates: '',
    actualState: '',
  }

  // User ID from the DB, not sure if this is the right place for it
  userId = '';

  constructor(private auth: AuthService, private http: HttpClient, private router: Router, private flashMessage: FlashMessagesService, private routeService: RouteService) { }

  // Get all users
  getAll(query?: Indexable) {
    let queryParams = new HttpParams({ fromObject: query });

    return this.http.get('api/v1/users/get-all', { params: queryParams });
  }

  // Get all RentWise users under an agency
  getRentwise(query?: Indexable) {
    let queryParams = new HttpParams({ fromObject: query });

    return this.http.get('api/v1/users/get-rentwise', { params: queryParams });
  }

   // Get all RentWise users for public records
   getRentwisePublic() {
    return this.http.get('api/v1/public/get-rentwise-users');
  }

  getFheUsers(query?: Indexable) {
    let queryParams = new HttpParams({ fromObject: query });

    return this.http.get('api/v1/users/get-fhe-users', { params: queryParams });
  }

  // Get all FHE users for public records
  getFhePublic() {
    return this.http.get('api/v1/public/get-fhe-users');
  }

  // Get RentWise progress for one user
  getRentwiseProgress(userID: any) {
    let queryParams = new HttpParams();
    queryParams = queryParams.append("userID", userID);
    return this.http.get('api/v1/public/get-rentwise-progress', {params: queryParams});
  }

  // Send request to convert geo coordinates to address
  findAddress(byCoords: { latitude: number; longitude: number }) {
    return this.http.post<any>('api/v1/public/user/address', byCoords);
  }

  async getCurrentPosition(options?: PositionOptions) {
    return new Promise<GeolocationPosition>((resolve, reject) => {
      try {
        navigator.geolocation.getCurrentPosition(resolve, reject, options);
      }
      catch (err) {
        reject(err);
      }
    });
  }

  // Register user
  async register(user: any, captcha: string, orderID: string|null) {
    const data = await this.auth.registerUser(user, captcha, orderID).toPromise();

    // Successful register
    if (data.success) {

      // Assign id for newly registered user
      user._id = data.user._id;

      // Store user data
      this.auth.storeUserData(data.token, data.user);
      this.auth.storeAdminStatus(false);

      this.user.signup = ''; // reset

      // Redirect to home page
      this.routeService.redirectAfterLogin();

      // Display log in to user
      this.flashMessage.show("User registered.", {
        cssClass: 'alert-success',
        timeout: 3000
      });

      return true;
    }

    // Registration failed
    else {
      this.router.navigate(['/sign-up']);

      // Display error to user
      this.flashMessage.show("User registration failed.", {
        cssClass: 'alert-danger',
        timeout: 3000
      });

      return false;
    }
  }

  // Check for existing email on first sign-up page
  checkEmailAvailability(email: any) {
    return this.auth.checkEmail(email).toPromise().then((data: any) => {

      // Email exists
      if (!data.success) {

        // Display error to user
        this.flashMessage.show("Email already exists.", {
          cssClass: 'alert-danger',
          timeout: 5000
        });
        this.router.navigate(['/sign-up']);
      }

      // Success, next page
      else {
        this.router.navigate(['/sign-up2']);
      }
    });
  }
}
